import {
  ACTA_CIERRE,
  ACTA_HALLAZGO,
  ACTA_INICIO,
  CASAS,
  EVENTOS,
  MONITOREOS_ESPECTACULARES,
  MONITOREOS_MEDIOS_IMPRESOS,
  MONITOREOS_INTERNET,
  MONITOREOS_VISITAS_VERIFICACION
} from 'constants/tipoMonitoreos';

export const convertirTipoPlantillaTipoMonitoreo = (tipoPlantilla) => {
  console.log(tipoPlantilla);
  switch (tipoPlantilla) {
    case 1:
      return { tipoMonitoreo: MONITOREOS_ESPECTACULARES, tipoActa: ACTA_INICIO };
    case 2:
      return { tipoMonitoreo: MONITOREOS_ESPECTACULARES, tipoActa: ACTA_HALLAZGO };
    case 3:
      return { tipoMonitoreo: MONITOREOS_ESPECTACULARES, tipoActa: ACTA_CIERRE };
    case 4:
      return { tipoMonitoreo: MONITOREOS_MEDIOS_IMPRESOS, tipoActa: null };
    case 5:
      return { tipoMonitoreo: MONITOREOS_INTERNET, tipoActa: null };
    case 6:
      return { tipoMonitoreo: MONITOREOS_VISITAS_VERIFICACION, tipoActa: EVENTOS };
    case 7:
      return { tipoMonitoreo: MONITOREOS_VISITAS_VERIFICACION, tipoActa: CASAS };
    default:
      return { tipoMonitoreo: 1, tipoActa: 1 };
  }
};
